
import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postSuccessTransaction = (params) => {
    return axios.post(`${backendHost}/api/admin/replenishment/success-transaction`, params);
};

export {
    postSuccessTransaction
}